import React from 'react'
import ComplementaryReviewInfo from 'components/ManualAnalysisList/ComplementaryReviewInfo'
import ReviewsList from 'components/ManualAnalysisList/ReviewsList'
import Container from './styles'

function ReviewAnalysis(props) {
  const { reviewData, onDataChanged } = props
  return (
    <Container>

      <ComplementaryReviewInfo review={reviewData} />

      <ReviewsList reviews={[reviewData]} onDataChanged={onDataChanged} />

    </Container>
  )
}

export default ReviewAnalysis
